import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrderAndPayment } from "./slices/OrdersSlice";
import "./OrderSummary.css";

const stateTaxRates = {
    Texas: 0.0625,
    California: 0.0725,
    NewYork: 0.04,
    Florida: 0.06,
    Illinois: 0.0625,
};

const OrderSummary = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { selectedItems, totalAmount, customer } = location.state || {};
    console.log(customer, "customer")
    //   const business = useSelector((state) => state.business.businesses[0]);
    const businessId = "6709f0331882028713f23319";

    const user = useSelector((state) => state.user.user);
    const { regularDiscounts } = useSelector((state) => state.pos);

    const [appliedDiscount, setAppliedDiscount] = useState(null);
    const [applicableDiscounts, setApplicableDiscounts] = useState([]);

    const taxRate = stateTaxRates["Texas"] || 0;

    useEffect(() => {
        const normalizedDiscounts = regularDiscounts.map((d) => ({
            _id: d.id,
            description: d.discount_data?.name,
            discountType: d.discount_data?.discount_type,
            amount: d.discount_data?.amount_money?.amount || d.discount_data?.percentage,
        }));
        setApplicableDiscounts(normalizedDiscounts);
    }, [regularDiscounts]);

    const calculateDiscount = () => {
        if (!appliedDiscount) return 0;

        switch (appliedDiscount.discountType) {
            case "FIXED_PERCENTAGE":
                return selectedItems.reduce((total, item) => {
                    const subtotal = (item.base_price_money.amount / 100) * item.quantity;
                    return total + (subtotal * appliedDiscount.amount) / 100;
                }, 0);

            case "FIXED_AMOUNT":
                return appliedDiscount.amount / 100;

            case "FREE_ITEM":
                const freeItem = selectedItems.find(item =>
                    appliedDiscount.description.toLowerCase().includes(item.name.toLowerCase())
                );
                return freeItem
                    ? Math.min(freeItem.base_price_money.amount / 100, freeItem.quantity * (freeItem.base_price_money.amount / 100))
                    : 0;

            default:
                return 0;
        }
    };

    const discountAmount = calculateDiscount();
    const taxAmount = (totalAmount - discountAmount) * taxRate;
    const totalWithTax = totalAmount - discountAmount + taxAmount;

    const handlePlaceOrder = () => {
        dispatch(
            createOrderAndPayment({
                items: selectedItems,
                amount: Math.round(totalWithTax * 100),
                paymentSource: "CASH",
                customerId: "guest_checkout", // You can keep a placeholder or null
                appliedDiscounts: appliedDiscount ? [appliedDiscount] : [],
                taxRate,
                businessId,
                userinfo: {
                    name: customer.name,
                    phone: customer.phone,
                },
            })
        )

            .unwrap()
            .then((res) => {
                navigate("/receipt", {
                    state: {
                        orderDetails: res,
                        customerName: user.name,
                        items: selectedItems,
                        taxAmount: taxAmount.toFixed(2),
                        totalWithTax: totalWithTax.toFixed(2),
                        totalAmount: totalAmount.toFixed(2),
                        discountAmount: discountAmount.toFixed(2),
                        businessId: businessId,
                    },
                });
            })
            .catch(console.error);
    };

    return (
        <div className="summary-container">
            <h2>Order Summary</h2>

            <div className="items-list">
                {selectedItems.map((item, idx) => (
                    <div key={idx} className="item-row">
                        <span>{item.name}</span>
                        <span>Qty: {item.quantity}</span>
                        <span>${((item.base_price_money.amount / 100) * item.quantity).toFixed(2)}</span>
                    </div>
                ))}
            </div>

            <div className="discounts-section">
                <h4>Discounts & Rewards</h4>
                {applicableDiscounts.map((d) => (
                    <button
                        key={d._id}
                        className={`discount-btn ${appliedDiscount?._id === d._id ? "selected" : ""}`}
                        onClick={() => setAppliedDiscount(d)}
                        disabled={appliedDiscount?._id === d._id}
                    >
                        {d.description}
                    </button>
                ))}
            </div>

            <div className="totals">
                <div><span>Subtotal:</span><span>${totalAmount.toFixed(2)}</span></div>
                <div><span>Discounts:</span><span>- ${discountAmount.toFixed(2)}</span></div>
                <div><span>Tax ({(taxRate * 100).toFixed(2)}%):</span><span>${taxAmount.toFixed(2)}</span></div>
                <div className="total-row"><strong>Total:</strong><strong>${totalWithTax.toFixed(2)}</strong></div>
            </div>

            <button className="place-order-btn" onClick={handlePlaceOrder}>Place Order</button>
        </div>
    );
};

export default OrderSummary;
